import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { SelectInput } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import {
  CONTRACT_SIDE_OPTIONS,
  ContractSide,
} from '@/pages/instruments/new-instrument/constants/sides'

export interface ContractSideFormFieldProps {}

export const ContractSideFormField: React.FC<ContractSideFormFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ contract_side: ContractSide }>()

  return (
    <FormField
      name="contract_side"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Contract Side - Long / Short</FormLabel>
              <FormError />
            </div>
            <SelectInput
              className={'flex flex-1 min-w-auto! w-full'}
              value={value?.toString()}
              onValueChange={(value) =>
                setValue('contract_side', value as ContractSide, { shouldValidate: true })
              }
              placeholder={'Select a contract side'}
              options={CONTRACT_SIDE_OPTIONS as unknown as any[]}
            />
          </FormItem>
        )
      }}
    />
  )
}
